<template>
    <div class="bgFrames">
        <img :src="realData.img" class="logoImg" />
        <div class="textContentFrame">
            <div class="contentTitle" v-html="realData.text"></div>
            <div class="contentMessage" v-html="realData.text1 + '<br>' + realData.text2"></div>
        </div>
    </div>
</template>

<script>

import {ref, onMounted, watch } from "vue";

export default {
  name: 'App',
  components: {
  },
   props: {
    data: Object,
  },
  setup(props) {
      watch(
        () => props.data,
            (newProps) => {
                realData.value = newProps
            }
        );
        const realData = ref({})
    onMounted(() => {
        realData.value = props.data
    });
    return {
        realData,
    };
  },
}
</script>

<style lang="less" scoped>
.bgFrames{
    width: 100%;
    height: 100%;
    border-radius: 16px;
    background: #E5E9D8;
}
.logoImg{
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    z-index: 500;
    background: #E5E9D8;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
}

.textContentFrame{
    position: absolute;
    z-index: 501;
    bottom: 0px;
    width: 100%;
    height: 230px;
    background: white;
    border-top-right-radius: 16px;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

}
.contentTitle{
    font-size: 16px;
    max-height: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: MicrosoftYaHeiLight;
    color: #333333;
    text-align: left;
    margin: 10px 11px 10px 11px;
}
.contentMessage{
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
    text-align: left;
    margin: 10px 11px 17px 11px;
}

</style>
